import { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { restorePlatformSession } from "./api/platformClient";
import { PlatformShell } from "./components/PlatformShell";
import { OneOrganisation } from "./screens/platform/OneOrganisation";
import { Organisations } from "./screens/platform/Organisations";
import { PlatformSignIn } from "./screens/platform/PlatformSignIn";
import { usePlatformSession } from "./usePlatformSession";

/**
 * The Healtrics console, under /platform (ADR-024).
 *
 * Its own component rather than a branch inside App, so that nothing here runs
 * the clinic portal's session restore and nothing there runs this one. Two
 * surfaces that share an origin are quite enough to share.
 *
 * The guard is a convenience, never a control. A signed-out person is kept off
 * a screen that would only show errors; every refusal that matters comes from
 * the server, and the clinical tables refuse this session at the database
 * whatever this component does (ADR-021, CLAUDE.md safety rule 1).
 */
export function PlatformApp() {
  const { signedIn } = usePlatformSession();
  const [restoring, setRestoring] = useState(true);

  useEffect(() => {
    void restorePlatformSession().finally(() => setRestoring(false));
  }, []);

  if (restoring) {
    return <p className="empty centred">Signing you back in…</p>;
  }

  if (!signedIn) {
    return <PlatformSignIn />;
  }

  return (
    <PlatformShell>
      <Routes>
        <Route index element={<Organisations />} />
        <Route path="organisations/:id" element={<OneOrganisation />} />
        <Route path="*" element={<Navigate to="/platform" replace />} />
      </Routes>
    </PlatformShell>
  );
}
